import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./MarineTerminal.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";

import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function MarineTerminal({ setPage }) {

    useEffect(() => {
    
      trackPageVisit("MarineTerminal");
    
    }, []);
  
     const {  valves, toggleValve, transmitters, updateTransmitter} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [ShowMDS, setShowMDS] = useState(false);
     

  const DEFAULT_VALVES = {
  FCV_1001: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("MarineTerminal_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1001: { ...DEFAULT_VALVES.FCV_1001, ...parsed.FCV_1001 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("MarineTerminal_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };






/* ================= MDS STATE PERSISTENCE ================= */

const [mdsState, setMdsState] = useState(() => {
  const saved = localStorage.getItem("MDS_state");
  return saved
    ? JSON.parse(saved)
    : {
        bargeType: "",
        crudeType: "",
        loadedBBL: 0,
      };
});

/* SAVE ON CHANGE */
useEffect(() => {
  localStorage.setItem("MDS_state", JSON.stringify(mdsState));
}, [mdsState]);


/* =========================================================
   CARGO INVENTORY MODEL (PROCESS-CORRECT VERSION)
========================================================= */

/* 1. ONE-TIME INFLOW (CARGO RECEIVED ONCE) */
const [inflowBBL, setInflowBBL] = useState(() => {
  const saved = localStorage.getItem("inflowBBL");
  return saved ? Number(saved) : 0;
});

useEffect(() => {
  localStorage.setItem(
    "inflowBBL",
    inflowBBL
  );
}, [inflowBBL]);

const [vesselDeparted, setVesselDeparted] = useState(false);


/* =========================================================
   FIXED BASE FOR PERCENTAGE (IMPORTANT FIX FOR 101% BUG)
========================================================= */
const inflowBaseRef = useRef(0);

/* =========================================================
   BARAGE CAPACITY (FIXED DESIGN VALUE)
========================================================= */
const BARGE_CAPACITY = 200000;
const bargeCapacity = BARGE_CAPACITY;

/* =========================================================
   LOAD CARGO (ONE-TIME EVENT)
========================================================= */
const loadCargo = (value) => {
  const safeValue = Number(value) || 0;

  setInflowBBL(safeValue);

  // lock reference for correct percentage scaling
  inflowBaseRef.current = safeValue;
};

/* =========================================================
   DERIVED LIVE INVENTORY
========================================================= */
const loadedBBL = Math.max(inflowBBL, 0);

/* =========================================================
   VISUAL HEIGHT
========================================================= */
const crudeHeight = Math.min(
  (loadedBBL / bargeCapacity) * 200,
  170
);










const [bargePosition, setBargePosition] = useState(() => {

  const saved =
    localStorage.getItem("bargePosition");

  return saved
    ? JSON.parse(saved)
    : {
        left: "-2000px",
        top: "300px",
      };

});

useEffect(() => {

  localStorage.setItem(
    "bargePosition",
    JSON.stringify(bargePosition)
  );

}, [bargePosition]);



const [isArrived, setIsArrived] = useState(() => {
  return JSON.parse(
    localStorage.getItem("isArrived")
  ) || false;
});

useEffect(() => {
  localStorage.setItem(
    "isArrived",
    JSON.stringify(isArrived)
  );
}, [isArrived]);



const [rotation, setRotation] = useState("0deg");

const handleBargeMovement = () => {

  // ================= ARRIVAL =================
  if (!isArrived) {

    setRotation("0deg");

    setBargePosition({
      left: "200px",
      top: "300px",
    });

    setIsArrived(true);

    localStorage.removeItem("MDS_state");
      setMdsState({
        bargeType: "",
        crudeType: "",
        loadedBBL: 0,
      });

  }

  // ================= DEPARTURE =================
  else {

    setRotation("180deg");

    setTimeout(() => {

      setBargePosition({
        left: "-2000px",
        top: "380px",
      });

    }, 300);

    setIsArrived(false);
  }
};











/* =========================================================
   PUMP CONTEXT
========================================================= */
const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   SHUTDOWN VALVE STATUS
========================================================= */
const xv1001Open = !valves?.XV_1001;
const xv1002Open = !valves?.XV_1002;

/* =========================================================
   SIS LOW LEVEL TRIP
========================================================= */
const lowLowLevelTrip =
  loadedBBL <= 300;

/* =========================================================
   VESSEL DEPARTURE TRIP
========================================================= */
const departureTrip =
  !isArrived;

/* =========================================================
   PUMP STATUS
========================================================= */
const isP1001AOn =
  pumpData?.["P-1001A"]?.running ?? false;

const isP1001BOn =
  pumpData?.["P-1001B"]?.running ?? false;

/* =========================================================
   SIS AUTO TRIP ACTION
========================================================= */
useEffect(() => {

  if (lowLowLevelTrip || departureTrip) {

    /* TRIP P-1001A */
    if (pumpData?.["P-1001A"]?.running) {

      togglePump("P-1001A");

    }

    /* TRIP P-1001B */
    if (pumpData?.["P-1001B"]?.running) {

      togglePump("P-1001B");

    }

  }

}, [
  lowLowLevelTrip,
  departureTrip,
  pumpData,
  togglePump
]);

/* =========================================================
   EFFECTIVE PUMP CONTRIBUTION
========================================================= */
const P1001A_Active =
  isP1001AOn &&
  xv1001Open &&
  !lowLowLevelTrip &&
  !departureTrip;

const P1001B_Active =
  isP1001BOn &&
  xv1002Open &&
  !lowLowLevelTrip &&
  !departureTrip;

/* =========================================================
   PUMP CAPACITY
========================================================= */
const pumpCapacity = 8.675;

/* =========================================================
   CONTROL VALVE
========================================================= */
const fcvOpening =
  Number(valveData?.FCV_1001?.opening || 0);

/* =========================================================
   FLOW CONTRIBUTION
========================================================= */
const P1001A_Flow =
  P1001A_Active
    ? pumpCapacity * (fcvOpening / 100)
    : 0;

const P1001B_Flow =
  P1001B_Active
    ? pumpCapacity * (fcvOpening / 100)
    : 0;

/* =========================================================
   TOTAL FLOW (INSTANTANEOUS)
========================================================= */
const targetFlow =
  P1001A_Flow + P1001B_Flow;

/* =========================================================
   FLOW INDICATOR (SMOOTH DCS BEHAVIOR)
========================================================= */
const [FIC_1001, setFIC_1001] = useState(() =>
  Number(
    localStorage.getItem("FIC_1001")
  ) || 0
);

useEffect(() => {

  localStorage.setItem(
    "FIC_1001",
    FIC_1001
  );

}, [FIC_1001]);



useEffect(() => {

  const interval = setInterval(() => {

    setFIC_1001(prev => {

      const systemActive =
        P1001A_Active || P1001B_Active;

      /* HARD RESET */
      if (
        !systemActive ||
        targetFlow === 0 ||
        lowLowLevelTrip ||
        departureTrip
      ) {
        return 0.0;
      }

      const next =
        prev + (targetFlow - prev) * 0.12;

      return Number(next.toFixed(2));

    });

  }, 100);

  return () => clearInterval(interval);

}, [
  targetFlow,
  P1001A_Active,
  P1001B_Active,
  lowLowLevelTrip,
  departureTrip
]);

/* =========================================================
   TOTAL FLOW
========================================================= */
const totalFlow = FIC_1001;




useEffect(() => {

  const now = Date.now();

  const lastTime =
    Number(
      localStorage.getItem(
        "MarineTerminal_LastSimTime"
      )
    ) || now;

  const elapsedSeconds =
    (now - lastTime) / 1000;

  if (elapsedSeconds <= 0) return;

  /*
     If pumps were running when page closed,
     calculate transferred volume.
  */

  const systemActive =
    P1001A_Active || P1001B_Active;

  if (!systemActive) return;

  const transferred =
    totalFlow * elapsedSeconds;

  setInflowBBL(prev =>
    Math.max(prev - transferred, 0)
  );

  setFIQ_1001(prev =>
    prev + transferred
  );

  localStorage.setItem(
    "MarineTerminal_LastSimTime",
    now
  );

}, []);



/* =========================================================
   LEVEL TRANSMITTER LOGIC
========================================================= */

/* prevent division by zero */
const safeBase =
  inflowBaseRef.current || 1;

/* CORRECT PERCENTAGE */
const levelPercent = Math.min(
  (inflowBBL / safeBase) * 100,
  100
);

/* =========================================================
   DISCHARGE MODEL
========================================================= */
useEffect(() => {

  const interval = setInterval(() => {

    setInflowBBL(prev => {

      /* NO FLOW */
      if (totalFlow <= 0) {
        return prev;
      }

      const next =
        prev - totalFlow;

      return next > 0 ? next : 0;

    });

  }, 1000);

  return () => clearInterval(interval);

}, [totalFlow]);

/* =========================================================
   PRESSURE MODEL
========================================================= */
const PT_1001 =
  totalFlow > 1 &&
  (xv1001Open || xv1002Open)
    ? 0.03 +
      (fcvOpening / 100) * 3.2
    : 0.03;

/* =========================================================
   TEMPERATURE MODEL
========================================================= */
const TT_1001 =
  totalFlow > 1 &&
  (xv1001Open || xv1002Open)
    ? 37
    : 25;

/* =========================================================
   GENERAL PUMP STATUS
========================================================= */
const isCargoPumpRunning =
  P1001A_Active || P1001B_Active;






  







/* =========================================================
   FIQ_1001 TOTALIZER
   Accumulates flow when FIC_1001 > 1
========================================================= */

const [FIQ_1001, setFIQ_1001] = useState(() => {

  return Number(
    localStorage.getItem("FIQ_1001")
  ) || 0;

});

const lastSimTimeRef = useRef(
  Number(localStorage.getItem("MarineTerminal_LastSimTime")) ||
  Date.now()
);

/* =========================================================
   TOTALIZER LOGIC
========================================================= */

useEffect(() => {

  const interval = setInterval(() => {

    /* ONLY TOTALIZE WHEN FLOW EXISTS */
    if (FIC_1001 > 1) {

      setFIQ_1001(prev => {

        /*
          FIC_1001 is BPM
          interval = 1 second

          Convert:
          barrels/minute → barrels/second
        */

        const increment = FIC_1001;

        return prev + increment;

      });

    }

  }, 1000);

  return () => clearInterval(interval);

}, [FIC_1001]);

/* =========================================================
   SAVE TOTALIZER
========================================================= */

useEffect(() => {

  localStorage.setItem(
    "FIQ_1001",
    JSON.stringify(FIQ_1001)
  );

}, [FIQ_1001]);

/* =========================================================
   RESET TOTALIZER
========================================================= */

const resetFIQ1001 = () => {

  setFIQ_1001(0);

  localStorage.setItem(
    "FIQ_1001",
    JSON.stringify(0)
  );

};


useEffect(() => {

  const interval = setInterval(() => {

    localStorage.setItem(
      "MarineTerminal_LastSimTime",
      Date.now()
    );

  }, 1000);

  return () => clearInterval(interval);

}, []);









useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1001 === FIC_1001 

  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1001,
    }
  });

}, [FIC_1001, ]);



              /* 🔥 ALARM ENGINE TAGS */
        
                const { evaluateTag } = useContext(AlarmContext);
        
                useEffect(() => {
                  evaluateTag("PT_1001", PT_1001);
                  

                }, [PT_1001, ]);
                



  return (
    <div className="MarineTerminal-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "275px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 143px",
          zIndex: 10,
        }}
      >
        MARINE TERMINAL FOR CRUDE UNLOADING
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1001 */}
      <Valve
        className="XV-1001"
        tag="XV_1001"
        x={761}
        y={148}
        isClosed={valves.XV_1001}
        toggle={toggleValve}
      />

      {/* XV-1002 */}
      <Valve
        className="XV-1002"
        tag="XV_1002"
        x={761}
        y={279}
        isClosed={valves.XV_1002}
        toggle={toggleValve}
      />



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1001 */}
        <div
            style={{ position: "absolute", left: 840, top: 139}}
            onMouseEnter={() => setHoveredValve("FCV_1001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1001")}
          >

            {hoveredValve === "FCV_1001" && (
              <div style={tagStyle}>
                FCV_1001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1001">
                    
          <defs>
            <linearGradient id="metal_1001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= MDS FACEPLATES RENDER ================= */}
          {ShowMDS && (
            <MDSFaceplate
              close={() => setShowMDS(false)}
              LT_1001={loadedBBL}
              pumpData={pumpData}
              valveData={valveData}
              defaultPosition={{
                x: 300,
                y: 150
              }}
            />
          )}


      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1001?.opening || 0)}
        x={861}
        y={183}
      />









      <button
        onClick={handleBargeMovement}
        style={{
          position: "fixed",
          top: "300px",
          left: "20px",
          padding: "10px 30px",
          background: "#001eff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          fontWeight: "bold",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        {isArrived ? "Departure" : "Arrival"}
      </button>


      <button
        onClick={resetFIQ1001}
        style={{
          position: "absolute",
          top: "178px",
          left: "1050px",

          padding: "5px 2px",

          background: "#1101f8",
          color: "#fff",

          border: "none",
          borderRadius: "4px",

          fontWeight: "bold",
          cursor: "pointer",

        }}
      >
        RESET FIQ
      </button>





      {/* ================= SVG RESIZE WRAPPER ================= */}
      <div
          style={{
            position: "absolute",
            left: bargePosition.left,
            top: bargePosition.top,
            width: "900px",
            height: "450px",
            transform: `scale(1) rotateY(${rotation})`,
            transformOrigin: "center center",
            transition: "left 8s linear, top 8s linear, transform 1s ease",
          }}
        >




        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1800 900"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid meet"
        >

          <defs>

            <linearGradient id="hullRed" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#c40000" />
              <stop offset="100%" stopColor="#6b0000" />
            </linearGradient>

            <linearGradient id="superstructure" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#f6f6f6" />
              <stop offset="100%" stopColor="#bfbfbf" />
            </linearGradient>

            <linearGradient id="windowBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0f5eff" />
              <stop offset="100%" stopColor="#002e8c" />
            </linearGradient>

          </defs>

          {/* ===================================================== */}
          {/* MAIN VESSEL */}
          {/* ===================================================== */}

          <g id="crudeBarge">

            {/* ===================================================== */}
            {/* HULL */}
            {/* ===================================================== */}

            <g id="hull">

              <path
                d="
                M80 620
                L1420 620
                L1620 670
                L1580 790
                L260 790
                L80 700
                Z"
                fill="url(#hullRed)"
                stroke="#3b0000"
                strokeWidth="4"
              />

              <rect
                x="70"
                y="585"
                width="1360"
                height="35"
                fill="#000"
              />

              <rect
                x="70"
                y="575"
                width="1360"
                height="10"
                fill="#d80000"
              />

              <rect
                x="90"
                y={790 - crudeHeight}
                width="1490"
                height={crudeHeight}
                fill="rgba(15,15,15,0.85)"
              />

            </g>

            {/* ===================================================== */}
            {/* HULL STIFFENERS */}
            {/* ===================================================== */}

            <g
              id="stiffeners"
              stroke="#900000"
              strokeWidth="6"
            >

              <line x1="500" y1="620" x2="450" y2="790" />
              <line x1="700" y1="620" x2="650" y2="790" />
              <line x1="900" y1="620" x2="850" y2="790" />
              <line x1="1100" y1="620" x2="1050" y2="790" />
              <line x1="1300" y1="620" x2="1250" y2="790" />

            </g>

            {/* ===================================================== */}
            {/* NK TECH BRANDING */}
            {/* ===================================================== */}

            <g id="branding">

              <text
                x="520"
                y="705"
                fontSize="100"
                fontWeight="900"
                fontFamily="Arial Black"
                fill="#ffffff"
                letterSpacing="4"
              >
                NK Tech
              </text>

            </g>

            {/* ===================================================== */}
            {/* PROPELLER TUNNELS */}
            {/* ===================================================== */}

            <g id="propellers">

              <rect
                x="120"
                y="700"
                width="45"
                height="90"
                fill="#8a0000"
              />

              <rect
                x="200"
                y="700"
                width="45"
                height="90"
                fill="#8a0000"
              />

              <circle
                cx="142"
                cy="780"
                r="22"
                fill="#c7a100"
              />

              <circle
                cx="222"
                cy="780"
                r="22"
                fill="#c7a100"
              />

            </g>

            {/* ===================================================== */}
            {/* MAIN DECK */}
            {/* ===================================================== */}

            <g id="mainDeck">

              <rect
                x="850"
                y="520"
                width="500"
                height="60"
                fill="#3b3b3b"
              />

              <rect
                x="860"
                y="500"
                width="480"
                height="15"
                fill="#0f5c0f"
              />

              <rect
                x="860"
                y="535"
                width="480"
                height="15"
                fill="#0f5c0f"
              />

            </g>

            {/* ===================================================== */}
            {/* CARGO PIPELINES */}
            {/* ===================================================== */}

            <g
              id="cargoLines"
              stroke="#0a6d0a"
              strokeWidth="8"
              fill="none"
            >

              <line x1="860" y1="510" x2="1320" y2="510" />
              <line x1="860" y1="545" x2="1320" y2="545" />

              <line x1="950" y1="485" x2="950" y2="565" />
              <line x1="1080" y1="485" x2="1080" y2="565" />
              <line x1="1210" y1="485" x2="1210" y2="565" />

            </g>

            {/* ===================================================== */}
            {/* PIPE VALVES */}
            {/* ===================================================== */}

            <g id="valves">

              <circle cx="950" cy="528" r="12" fill="#cc0000" />
              <circle cx="1080" cy="528" r="12" fill="#cc0000" />
              <circle cx="1210" cy="528" r="12" fill="#cc0000" />

            </g>

            {/* ===================================================== */}
            {/* SUPERSTRUCTURE LOWER */}
            {/* ===================================================== */}

            <g id="lowerHouse">

              <rect
                x="260"
                y="430"
                width="600"
                height="150"
                fill="url(#superstructure)"
                stroke="#666"
                strokeWidth="3"
              />

            </g>

            {/* ===================================================== */}
            {/* WINDOWS */}
            {/* ===================================================== */}

            <g id="windows">

              <rect x="330" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="390" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="450" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="510" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="570" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="630" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />
              <rect x="690" y="470" width="40" height="35" rx="5" fill="url(#windowBlue)" />

            </g>

            {/* ===================================================== */}
            {/* WHEELHOUSE */}
            {/* ===================================================== */}

            <g id="wheelhouse">

              <rect
                x="500"
                y="270"
                width="220"
                height="160"
                fill="url(#superstructure)"
                stroke="#666"
                strokeWidth="3"
              />

              <polygon
                points="
                480,270
                740,270
                710,240
                510,240"
                fill="#b00000"
              />

              <rect x="530" y="300" width="45" height="40" fill="#0048ff" />
              <rect x="585" y="300" width="45" height="40" fill="#0048ff" />
              <rect x="640" y="300" width="45" height="40" fill="#0048ff" />

            </g>

            {/* ===================================================== */}
            {/* FUNNEL */}
            {/* ===================================================== */}

            <g id="funnel">

              <rect
                x="310"
                y="310"
                width="85"
                height="110"
                fill="#202020"
              />

              <rect
                x="310"
                y="310"
                width="85"
                height="25"
                fill="#93fd09"
              />

            </g>

            {/* ===================================================== */}
            {/* LADDER */}
            {/* ===================================================== */}

            <g
              id="ladder"
              stroke="#d0d0d0"
              strokeWidth="3"
            >

              <line x1="360" y1="430" x2="430" y2="320" />
              <line x1="380" y1="430" x2="450" y2="320" />

              <line x1="365" y1="410" x2="440" y2="410" />
              <line x1="370" y1="390" x2="445" y2="390" />
              <line x1="375" y1="370" x2="450" y2="370" />
              <line x1="380" y1="350" x2="455" y2="350" />

            </g>

            {/* ===================================================== */}
            {/* RAILINGS */}
            {/* ===================================================== */}

            <g
              id="railings"
              stroke="#dddddd"
              strokeWidth="3"
            >

              <line x1="230" y1="420" x2="870" y2="420" />
              <line x1="230" y1="400" x2="870" y2="400" />

              <line x1="230" y1="420" x2="230" y2="520" />
              <line x1="280" y1="420" x2="280" y2="520" />
              <line x1="330" y1="420" x2="330" y2="520" />
              <line x1="380" y1="420" x2="380" y2="520" />
              <line x1="430" y1="420" x2="430" y2="520" />
              <line x1="480" y1="420" x2="480" y2="520" />
              <line x1="530" y1="420" x2="530" y2="520" />
              <line x1="580" y1="420" x2="580" y2="520" />
              <line x1="630" y1="420" x2="630" y2="520" />
              <line x1="680" y1="420" x2="680" y2="520" />
              <line x1="730" y1="420" x2="730" y2="520" />
              <line x1="780" y1="420" x2="780" y2="520" />
              <line x1="830" y1="420" x2="830" y2="520" />

            </g>

            {/* ===================================================== */}
            {/* LIFE BUOYS */}
            {/* ===================================================== */}

            <g id="lifebuoys">

              <circle
                cx="520"
                cy="420"
                r="16"
                fill="none"
                stroke="#ff4444"
                strokeWidth="6"
              />

              <circle
                cx="270"
                cy="500"
                r="16"
                fill="none"
                stroke="#ff4444"
                strokeWidth="6"
              />

            </g>

            {/* ===================================================== */}
            {/* MAST */}
            {/* ===================================================== */}

            <g id="mast">

              <line
                x1="620"
                y1="120"
                x2="620"
                y2="270"
                stroke="#666"
                strokeWidth="5"
              />

              <line
                x1="620"
                y1="170"
                x2="690"
                y2="170"
                stroke="#666"
                strokeWidth="3"
              />

              <rect
                x="690"
                y="162"
                width="12"
                height="12"
                fill="green"
              />

              <rect
                x="708"
                y="162"
                width="12"
                height="12"
                fill="red"
              />

            </g>

            {/* ===================================================== */}
            {/* ANTENNAS */}
            {/* ===================================================== */}

            <g
              id="antennas"
              stroke="#444"
              strokeWidth="3"
            >

              <line x1="560" y1="240" x2="560" y2="180" />
              <line x1="590" y1="240" x2="590" y2="170" />
              <line x1="650" y1="240" x2="650" y2="185" />

            </g>

          </g>

        </svg>






       
        <div
          onMouseDown={handleMouseDown}
          style={{
            position: "absolute",
            top: panelPos.y,
            left: panelPos.x,
            zIndex: 2000,
            background: "black",
            padding: "10px",
            borderRadius: "6px",
            color: "white",
            cursor: "move",
            userSelect: "none",
          }}
        >
          <label style={{ fontSize: "12px" }}>
            Loaded BBL:
          </label>

          <input
            type="number"
            value={inflowBBL}
            onChange={(e) =>
              setInflowBBL(Number(e.target.value) || 0)
            }
            style={{ marginLeft: "8px" }}
          />

          <div style={{ marginTop: "5px", fontSize: "12px" }}>
            Barge Capacity: {bargeCapacity.toFixed(2)}
          </div>
        </div>




        <button
          onClick={() => {
                  setShowMDS(true);
                }}
          style={{
            position: "fixed",
            top: "175px",
            left: "270px",
            padding: "10px 25px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 2000,
            boxShadow: "0 3px 8px rgba(0,0,0,0.4)"
          }}
        >
          MDS
        </button>

      </div>


       <Transmitter
          tag="FIC_1001"
          value={[FIC_1001]}
          x={925}
          y={185}
          unit="BPM"
          max={15}
          HH={13}
          H={9}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS TO TANK FARM"
         />
        
        <Transmitter
          tag="PT_1001"
          value={[PT_1001]}
          x={925}
          y={127}
          unit="MPa"
          max={4}
          HH={2.6}
          H={2.5}
          L={0.5}
          LL={0.3}
          c="lime"
          description="PRESSURE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS TO TANK FARM"
         />
        
        <Transmitter
          tag="TT_1001"
          value={[TT_1001]}
          x={925}
          y={87}
          unit="°C"
          max={100}
          HH={70}
          H={50}
          L={22}
          LL={20}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS TO TANK FARM"
         />


        <Transmitter
          tag="FIQ_1001"
          value={[FIQ_1001]}
          x={1050}
          y={132}
          unit="BBL"
          max={100000}
          HH={90000}
          H={80000}
          L={0}
          LL={0}
          c="cyan"
          description="TOTALIZED FLOW OF CRUDE TRANSFERRED FROM MARINE TERMINAL BARGES TO CRUDE TANKS"
        />
  



            <Pump
              tag="P-1001A"
              x={649}
              y={154}
              rpm={1800}
              bladeCount={pumpData?.["P-1001A"]?.bladeCount || 3}
              size={pumpData?.["P-1001A"]?.size || 50}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1001B"
              x={649}
              y={285}
              rpm={1800}
              bladeCount={pumpData?.["P-1001B"]?.bladeCount || 3}
              size={pumpData?.["P-1001B"]?.size || 50}
              onClick={openPumpPanel}
            />


    </div>
  );
}

export default MarineTerminal;